export default "__VITE_ASSET__$S8qXL$L__"